export default {
  resdashboard: "لوحة التحكم",
  resdashboard_subtitle: "مرحبًا بعودتك! هذا ملخص المطعم اليوم",

  rescredit_limit: "حد الائتمان",
  resused_credit: "الائتمان المستخدم",
  resavailable_credit: "المتاح",
  resnext_due_date: "تاريخ الاستحقاق",

  restoday_orders: "طلبات اليوم",
  restotal_revenue: "إجمالي الإيرادات",
  restotal_customers: "إجمالي العملاء",
  resavg_rating: "متوسط التقييم",

  resrecent_orders: "الطلبات الأخيرة",
  resorder_id: "رقم الطلب",
  rescustomer: "العميل",
  resamount: "المبلغ",
  resstatus: "الحالة",
  resno_recent_orders: "لا توجد طلبات حديثة",

  restop_selling_items: "الأكثر مبيعًا",
resitem_biryani: "برياني دجاج",
  resitem_paneer: "بانير بالزبدة",
  resitem_fried_rice: "أرز مقلي",
  resorders: "طلبات",
    resjan: "يناير",
  resfeb: "فبراير",
  resmar: "مارس",
  resapr: "أبريل",
  resmay: "مايو",
  resjun: "يونيو",

  ressales_label: "المبيعات (ريال قطري)",
  resorders: "طلبات",

  ressales_overview: "نظرة عامة على المبيعات",
  resorders_overview: "نظرة عامة على الطلبات",
    ressupplier: "المورد",

  restoday_spend: "إنفاق اليوم",
  respending_orders: "الطلبات المعلقة",
  restotal_orders: "إجمالي الطلبات",

  resmonthly_spend: "الإنفاق الشهري",
  resmonthly_spend_label: "الإنفاق الشهري (ر.ق)",

  restop_suppliers: "أفضل الموردين",
  resamount_qar: "المبلغ (ر.ق)",

  resorder_status: "حالة الطلبات",

  resorders: "الطلبات",
  resplaced: "تم الطلب",
resaccepted: "تم القبول",
respacked: "تم التعبئة",
resdelivered: "تم التوصيل",
resrejected: "مرفوض",
resout_for_delivery: "خرج للتوصيل",
resjan: "يناير",
resfeb: "فبراير",
resmar: "مارس",
resapr: "أبريل",
resmay: "مايو",
resjun: "يونيو",
resjul: "يوليو",
resaug: "أغسطس",
ressep: "سبتمبر",
resoct: "أكتوبر",
resnov: "نوفمبر",
resdec: "ديسمبر",
};